<template>
  <div class="main-container">
    <div class="page-title">
      <div class="title">上架款式</div>
      <div class="slogan">上传自己设计款式 分享出去让更多人看到</div>
    </div>
    <div class="base-info">
      <div class="base-container">
        <div class="reason-box" v-if="form_data.reason">
          <div class="reason-title">
            <span>i</span>驳回原因:
          </div>
          <div class="reason-content">{{form_data.reason}}</div>
        </div>
        <div class="base-title">基础信息</div>
        <div class="form">
          <div class="form-item">
            <div class="item-label-required">款式标题</div>
            <div class="item-value">
              <Input placeholder="请输入款式标题" v-model="form_data.name" :maxlength="50">
                <template slot="suffix">
                  <div style="color: #999999; padding-right: 10px">
                    {{ form_data.name.length }}/50
                  </div>
                </template>
              </Input>
            </div>
          </div>
          <div class="form-item" v-if="!showToolTip && form_data.design_id < 1">
            <div class="item-label-required">款式品类</div>
            <div class="item-value-select">
              <Select v-model="form_data.parent_product_category_id" @on-change="onParentChange">
                <Option
                  v-for="(item, index) in design_category_list"
                  :key="index"
                  :value="item.product_category_id"
                  >{{ item.category_name_cn }}</Option
                >
              </Select>
            </div>
            <div
              class="item-value-select"
              v-if="child_design_category_list.length > 0"
            >
              <Select v-model="form_data.child_product_category_id" @on-change="onSubCateChange">
                <Option
                  v-for="(item, index) in child_design_category_list"
                  :key="index"
                  :value="item.product_category_id"
                  >{{ item.category_name_cn }}</Option
                >
              </Select>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label-required">款式分类</div>
            <div class="item-value-select">
              <Select v-model="form_data.category_id_1" @on-change="onMainCateChange">
                <Option
                  v-for="(item, index) in product_category_list"
                  :key="index"
                  :value="item.product_category_id"
                  >{{ item.category_name_cn }}</Option
                >
              </Select>
            </div>
            <div
              class="item-value-select"
              v-if="child_category_list.length > 0"
            >
              <Select v-model="form_data.category_id_2" @on-change="onSubCateChange">
                <Option
                  v-for="(item, index) in child_category_list"
                  :key="index"
                  :value="item.product_category_id"
                  >{{ item.category_name_cn }}</Option
                >
              </Select>
            </div>
            <div class="item-label-required">适用性别</div>
              <div class="item-value-select">
                <Tooltip :disabled="showToolTip" placement="top" content="请选择品类">
                  <Select v-model="form_data.sex" @on-change="onChangeSex">
                    <!-- <Option :value="0">不限</Option> -->
                    <Option :value="1" :disabled="!showToolTip && !style_category.product_category_id">男</Option>
                    <Option :value="2" :disabled="!showToolTip && !style_category.product_category_id">女</Option>
                    <Option :value="3" :disabled="!showToolTip && !style_category.product_category_id">童</Option>
                  </Select>
                </Tooltip>
              </div>
          </div>
          <div class="form-item">
            <div class="item-label-required">发货模式</div>
            <div class="item-value-select">
              <RadioGroup v-model="form_data.delivery_mode">
                <Radio label="0">平台发货</Radio>
                <Radio label="1">自己发货</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="form-item" style="align-items: baseline">
            <div class="item-label-required">商品主图</div>
            <div class="item-value-img">
              <div class="tips">
                支持上传图片或视频(限一个),建议尺寸800x1060像素,最小高度不低于430像素,首图将作为商品封面
              </div>
              <div class="img-box">
                <!-- <Upload
                  :action="upload_url"
                  :data="{ dir: 'template' }"
                  :show-upload-list="false"
                  :before-upload="(file) => onBeforeUpload(file, 'cover')"
                >
                  <div v-if="!form_data.image" class="img-item">
                    <div class="poster">封面图</div>
                    <img
                      src="../../../assets/images/icon-upload.png"
                      alt=""
                      class="up-icon"
                    />
                    <div class="up-text">上传图片</div>
                  </div>
                  <div class="imgs" v-else>
                    <div class="poster">封面图</div>
                    <img class="imgs" :src="form_data.image" />
                  </div>
                </Upload> -->

                <div
                  class="imgs"
                  v-for="(item, index) in form_data.image_list"
                  :key="index"
                  :data-index="index"
                  draggable
                  @dragstart="handleDragStart($event, index)"
                  @dragover.prevent
                  @drop="handleDrop($event, index)"
                >
                  <img
                    v-if="item.type === 'image' || !item.type"
                    :src="item.raw | default_img" v-viewer
                    alt=""
                  />
                  <video v-else :src="item.raw" controls></video>
                  <img
                    @click.stop="onImgListDel(index)"
                    src="../../../assets/images/icon-close-circle.png"
                    alt=""
                    class="remove-icon"
                  />
                  <div v-if="item.type === 'image'" class="set-poster" @click.prevent.stop="setPoster(item.raw)">
                    设为封面
                  </div>
                  <div v-if="item.raw === form_data.image" class="poster">封面图</div>
                </div>
                <!-- <img
                  v-for="(item, index) in 10"
                  :key="index"
                  :src="item.raw | default_img"
                  alt=""
                  class="imgs"
                /> -->
                <Upload
                  :action="upload_url"
                  :data="{ dir: 'product' }"
                  :show-upload-list="false"
                  :before-upload="(file) => onBeforeUpload(file, 'list')"
                  multiple
                >
                  <div class="img-item">
                    <img
                      src="../../../assets/images/icon-up-img-video.png"
                      alt=""
                      class="up-icon"
                    />
                    <div class="up-text">上传图片/视频</div>
                  </div>
                </Upload>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="item-label-required">款式说明</div>
            <div class="item-value-textarea">
              <textarea
                placeholder="请输入款式说明"
                v-model="form_data.description"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-info">
      <div class="detail-container">
        <div class="title-line">
          <div class="base-title">款式参数信息</div>
          <div class="add-param-btn" @click="add_param">添加参数</div>
        </div>
        <div class="detail-form">
          <div
            class="detail-form-item"
            v-for="(item, index) in form_data.param"
            :key="index"
          >
            <!-- <img src="../../../assets/images/icon-close-circle.png" @click="onParamDel(index)" alt="移除选项" class="del-item"> -->
            <Tooltip content="移除选项" placement="top" class="param-del-item-tooltip">
              <img src="@/assets/images/icon-close-circle.png" @click="onParamDel(index)" alt="移除选项" class="del-item">
            </Tooltip>
            <div
              :class="[
                'form-item-label',
                { 'form-item-label-required': item.required },
              ]"
            >
              <input
                v-model="item.key"
                :readonly="item.key_ro"
                placeholder="输入参数名"
              />
            </div>
            <div class="form-item-value">
              <input :placeholder="`请输入${item.key}`" v-model="item.value" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="size-info" v-if="field_list.length && size_list_for_field.length">
      <div class="size-container">
        <div class="base-title">款式尺码表</div>
        <table>
          <thead>
            <tr>
              <th>尺码</th>
              <th v-for="(item, index) in field_list" :key="index">
                {{ item.field_name_cn }}(cm)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(size, index) in size_list_for_field" :key="`body${index}`">
              <td>{{ size }}</td>
              <td v-for="(field, i) in field_list" :key="`body-td-${i}`">
                {{ size_info[size][field.field_key].normal }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="size-tips">
          <span class="tips-label">温馨提示:</span>
          <span>手工测量平铺尺寸可能与实际尺寸存在1-3CM的误差,请谅解.</span>
        </div>
      </div>
    </div>
    <div class="sale-info">
      <div class="sale-container">
        <div class="base-title" style="margin-bottom: 35px">销售信息</div>
        <div class="choose-label">尺码选择({{ selected_size.length }})</div>
        <div class="choose-form">
          <div class="form-item-box">
            <div
              class="form-item"
              v-for="(size, size_index) in selected_size"
              :key="size_index"
            >
              <div class="item-name">{{ size.size_key }}</div>
              <Icon type="ios-close" class="del-item" @click="onDelSelectedSize(size)" />
            </div>
          </div>
          <div class="add-btn" @click="onAddSize">添加尺码</div>
        </div>
        <div class="choose-label">颜色选择({{ selected_color.length }})</div>
        <div class="choose-form">
          <div class="form-item-box">
            <div
              class="form-item"
              v-for="(color, color_index) in selected_color"
              :key="color_index"
            >
              <Upload action="/"
                  :data="{ dir: 'product' }"
                  :before-upload="(file)=>onBeforeColorUpload(file,color_index)"
                  :show-upload-list="false">
                <img :src="color && color.color_image ? color.color_image : require('../../../assets/images/shop-manage/icon-product-color-default.png')" class="color-img" />
              </Upload>
              <div class="item-name">{{ color.color_name_cn }}</div>
              <Icon type="ios-close" class="del-item" @click="onDelSelectedColor(color.color_id)" />
            </div>
          </div>
          <div class="add-btn" @click="openColorPopup">添加颜色</div>
        </div>
        <div class="sale-form">
          <div class="sale-form-item">
            <div class="sale-form-item-label required">计量单位</div>
            <div class="sale-form-item-value">
              <Input v-model="form_data.unit" placeholder="请输入产品计量单位,如:件,条,套"></Input>
            </div>
          </div>
          <div class="sale-form-item">
            <div class="sale-form-item-label">销售数量</div>
            <div class="sale-form-item-value">
              <Input v-model="form_data.sales" type="number" placeholder="请输入您的款式商品销量"></Input>
            </div>
          </div>
          <div class="sale-form-item">
            <div class="sale-form-item-label required">报价方式</div>
            <div class="sale-form-item-value">
              <RadioGroup v-model="form_data.price_mode" @on-change="onPriceModeChange">
                <Radio label="2">按产品数量报价</Radio>
                <Radio label="1">按产品规格报价</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="sale-form-item">
            <div class="sale-form-item-label required">吊牌价</div>
            <div class="sale-form-item-value">
              <Input v-model="form_data.tag_price" type="number" placeholder="请输入您的款式商品吊牌显示价格,页面显示为划线价格"></Input>元
            </div>
          </div>
          <div class="sale-form-item" v-if="form_data.price_mode == 1">
            <div class="sale-form-item-label required">最小起订量</div>
            <div class="sale-form-item-value">
              <Input v-model="form_data.mqq" type="number" placeholder="请输入最小起订数"></Input>件
            </div>
          </div>
          <div class="sale-form-item align-start" v-if="form_data.price_mode == 2">
            <div class="sale-form-item-label required">区间报价</div>
            <div class="sale-form-item-value">
              <table>
                <thead>
                  <tr>
                    <th>购买数量</th>
                    <th>单价(元)</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- form_data.price_step -->
                  <tr v-for="(item,index) in form_data.price_step" :key="`ps-${index}`" class="no-hover">
                    <td>
                      <div class="input-no-border">
                        <Input @on-blur="onPriceStepInput($event,index,'num')" type="number" v-model="item.min" placeholder="请输入"></Input>
                      </div>
                    </td>
                    <td>
                      <div class="input-no-border">
                        <Input @on-blur="onPriceStepInput($event,index,'price')" type="number" v-model="item.price" placeholder="请输入"></Input>
                      </div>
                    </td>
                    <td class="no-padding">
                      <div class="price-step-op">
                        <Icon type="md-remove" :class="['cursor',{disabled:form_data.price_step.length == 1}]" @click="onPriceStepRemove(index)" />
                        <Icon type="md-add" :class="['cursor',{disabled:form_data.price_step.length >= 3}]" @click="onPriceStepAdd" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="sale-form-item align-start">
            <div class="sale-form-item-label required">可售数量</div>
            <div class="sale-form-item-value">
              <table>
                <thead>
                  <tr>
                    <th>尺码</th>
                    <th>颜色</th>
                    <th>颜色图片</th>
                    <th v-if="form_data.price_mode == 1">
                      <div class="batch-col">
                        价格 <span @click="onBatchset('price')">批量设置</span>
                      </div>
                    </th>
                    <th>
                      <div class="batch-col">
                        库存数量 <span @click="onBatchset('stock')">批量设置</span>
                      </div>
                    </th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in size_color_table_data" :key="index">
                    <td>
                      <div class="size-selected">
                        <img
                          src="../../../assets/images/icon-edit-pink.png"
                          alt=""
                          class="icon-edit cursor" @click="onModifySize(item.size,index)"
                        />
                        {{ item.size.size_alias }}
                      </div>
                    </td>
                    <td>
                      <div class="color-selected">
                        <img
                          src="../../../assets/images/icon-edit-pink.png"
                          alt=""
                          class="icon-edit cursor" @click="onModifyColor(item.color,index)"
                        />
                        {{ item.color.color_name || item.color.color_name_cn }}
                      </div>
                    </td>
                    <td>
                      <div class="color-img-col">
                        <img v-viewer :src="item.color.color_image || require('../../../assets/images/shop-manage/icon-product-color-default.png')" alt="" :class="['color-img',{'has-img':item.color.color_image,'no-img':!item.color.color_image}]" />
                        <template v-if="!item.color.color_image">
                          <Upload
                            action="/"
                            :data="{ dir: 'product' }"
                            :before-upload="(file)=>onColorImgUploadForTable(file,index)"
                            :show-upload-list="false"
                          >
                            <div class="img-btn">添加</div>
                          </Upload>
                        </template>
                        <div v-else class="img-btn" @click="size_color_table_data[index].color.color_image=''">删除</div>
                      </div>
                    </td>
                    <td v-if="form_data.price_mode == 1">
                      <input placeholder="请输入价格" type="number" v-model="item.price" />
                    </td>
                    <td>
                      <input placeholder="请输入库存" type="number" v-model="item.stock" />
                    </td>
                    <td>
                      <div class="operate-selected" @click="onDelTableData(item.color,item.size)">删除</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- <div class="choose-label">已选择销售尺码/颜色</div> -->
      </div>
    </div>
    <div class="detail-content-info">
      <div class="detail-container">
        <div class="base-title" style="margin-bottom: 30px">图文详情</div>
        <Editor style="z-index:1 !important;"
          v-model="form_data.content"
          :is-clear="true" dir="product"
          @change="change_richtext"
        ></Editor>
      </div>
    </div>
    <div class="bottom-menu">
      <div class="btn-items" @click="asyncShop" v-show="false">一键铺货</div>
      <div class="btn-items" @click="save(true)" v-if="is_new">保存</div>
      <div class="btn-items" @click="save(false)" v-else>提交</div>
    </div>
    <!-- 批量设置价格/库存 -->
    <popup
      :show.sync="is_batch_pop_show"
      height="100px"
      width="360px"
      @on-close="onCancelBatchSet"
    >
      <div class="popup">
        <div class="title">批量设置{{ batch_type === 'price' ? '价格' : '库存' }}</div>
        <div class="batch-form">
          <div class="batch-form-item">
            <!-- <div class="batch-form-item-label">价格</div> -->
            <input :placeholder="`请输入${batch_type === 'price' ? '价格' : '库存'}`" type="number" v-model="batch_val" />
          </div>
          <div class="btn-box">
            <Button @click="onCancelBatchSet">取消</Button>
            <Button @click="onConfirmBatchSet">确认</Button>
          </div>
        </div>
      </div>
    </popup>
    <!-- 增加尺码弹窗 -->
    <popup
      :show.sync="is_choose_size_popup_show"
      height="300px"
      width="960px"
      @on-close="()=>is_choose_size_popup_show=false"
    >
      <div class="popup">
        <div class="title">尺码选择</div>
        <div class="color-list size-list">
          <div
            class="color-item cursor"
            :class="{ active: temp_size_ids.includes(v) }"
            v-for="(v, k) in size_list" :key="k"
            @click="toggle_size(v)"
          >
            <span>{{ v }}</span>
          </div>
        </div>
        <div class="btn-modify cursor" @click="confirm_choose_size_popup">
          确定
        </div>
      </div>
    </popup>
    <!-- 修改尺码名称弹窗 -->
    <popup
      :show.sync="is_modify_size_show"
      height="250px"
      width="520px"
      @on-close="()=>is_modify_size_show=false"
    >
      <div class="popup">
        <div class="title">尺码名称</div>
        <div class="form-group">
          <div class="label">自定义名称</div>
          <input class="input" v-model="form_data_custom_size.size_alias" />
        </div>
        <div class="tip">
          <span>温馨提示：</span>
          自定义名称信息会显示在吊牌、水洗标、领标等物料上，
          如果未填写会显示尺码名称。
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_size">
          确认修改
        </div>
      </div>
    </popup>

    <!-- 增加颜色弹窗 -->
    <popup
      :show.sync="is_choose_color_popup_show"
      height="650px"
      width="960px"
      @on-close="()=>is_choose_color_popup_show=false"
    >
      <div class="popup">
        <div class="title">面料颜色色号选择</div>
        <div class="color-list">
          <div
            class="color-item cursor"
            :class="{ active: temp_color_ids.includes(v.color_id) }"
            v-for="(v, k) in sys_color_list" :key="`sys-${k}`"
            @click="toggle_color(v.color_id)"
          >
            <img :src="v.color_value | default_img" alt="" />
            <span>{{ v.color_name_cn }}</span>
          </div>
          <div
            class="color-item cursor"
            :class="{ active: temp_color_ids.includes(v.color_id) }"
            v-for="(v, k) in color_list" :key="`custom-${k}`"
            @click="toggle_color(v.color_id)"
          >
            <span>{{ v.color_name }}</span>
            <img
              v-if="color_list.map((v) => v.color_id).includes(v.color_id)"
              src="@/assets/images/design/icon-del.png"
              alt=""
              class="icon-del cursor"
              @click.stop="del_custom_color(v.color_id)"
            />
          </div>
        </div>
        <div class="btn-modify cursor" @click="confirm_choose_color_popup">
          确定
        </div>

        <div class="form-group">
          <div class="label">自定义添加颜色</div>
          <input class="input" v-model="form_data_custom_color.color_alias" />
          <div class="btn-add cursor" @click="add_custom_color">点击添加</div>
        </div>
        <div class="tip">
          <span>温馨提示：</span>
          自定义颜色信息会显示在吊牌、水洗标、领标等物料上，
          如果未填写会显示颜色名称。
        </div>
      </div>
    </popup>

    <!-- 修改颜色名称弹窗 -->
    <popup
      :show.sync="is_modify_color_show"
      height="250px"
      width="520px"
      @on-close="()=>is_modify_color_show=false"
    >
      <div class="popup">
        <div class="title">颜色名称</div>
        <div class="form-group">
          <div class="label">自定义名称</div>
          <input class="input" v-model="form_data_modify_color.color_name" />
        </div>
        <div class="tip">
          <span>温馨提示：</span>
          自定义名称信息会显示在吊牌、水洗标、领标等物料上，
          如果未填写会显示颜色色号。
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_color">
          确认修改
        </div>
      </div>
    </popup>
    <popup :show.sync="is_popup_show" width="500px" height="250px" @on-close="close">
			<h2>选择店铺</h2>
			<div class="form">
				<div class="form-group w50">
            <div class="form-label">店铺：</div>
            <div class="form-control">
                <select v-model="shop_id">
                    <option
                        v-for="(v, k) in shop_list"
                        :key="`dpc1` + k"
                        :value="v.id"
                    >
                        {{ v.shop_name }}
                    </option>
                </select>
            </div>
        </div>
				<div class="btn-submit" @click="getShopInfo">确认</div>
			</div>
		</popup>
    <KuaiEdit ref="KuaiEdit" :shop_id="shop_id" :product="form_data" @getProduct="getProduct"></KuaiEdit>
  </div>
</template>

<script>
import {
  GetDesign,
  getMallCategoryList,
  GetProduct,
  getSetting,
  ProductCategoryList,
  Profile,
  SaveProduct
} from "@/api/index.js";
import { GetMyShopList } from "@/api/open";
import Popup from "@/components/Popup.vue";
import Editor from "@/components/WangEditor";
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
import axios from "axios";
import KuaiEdit from "./components/KuaiEdit";


const form_data = {
  id: 0,
  name: "",
  image: "",
  status: 1,
  sex: 0,
  design_id: 0,
  category_id: 0,
  category_id_1: 0,
  category_id_2: 0,
  description: "",
  param: [
    { key: "款号", value: "", required: true, key_ro: true },
    { key: "服装版型", value: "", key_ro: true },
    { key: "适用季节", value: "", key_ro: true },
    { key: "厚薄", value: "", key_ro: true },
    { key: "面料成分", value: "", required: true, key_ro: true },
    { key: "里料成分", value: "", required: true, key_ro: true },
  ],
  detail: "",
  uuid: "",
  image_list: [],
  price_mode:0,
  tag_price:0,
  sale_price:0,
  sales:0,
};

export default {
  name: "ProductEdit",
  components: {
    Editor,
    Popup,
    KuaiEdit
  },
  data() {
    return {
      design_uuid: "",
      uuid: "",
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      form_data: { ...form_data },
      design_list: [],
      product_category_list: [],
      shop_list: [],
      is_popup_show: false,
      shop_id: 0,
      uploading: false,
      uploadQueue: [],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
      image_list: [],
      size_info: [],
      size_list: [],
      field_list: [],
      size_list_for_field:[],
      color_list:[],
      selected_size: [],
      selected_color: [],
      is_choose_color_popup_show:false,
      is_choose_size_popup_show:false,
      is_modify_color_show:false,
      is_modify_size_show:false,
      // sale_size_list:[],
      // sale_color_list:[],
      temp_size_ids:[],
      temp_color_ids:[],
      sys_color_list:[
        // {
        //   color_id: -1,
        //   color_key: -1,
        //   color_name: "默认色",
        //   color_name_cn: "默认色",
        //   color_value: "",
        // },
      ],
      form_data_custom_color: {
        id: 0,
        color_alias: "",
      },
      form_data_custom_size: {
        size_key: "",
        size_alias: "",
      },
      size_color_table_data:[],
      form_data_modify_color: {
        color_id: 0,
        color_name: "",
      },
      is_batch_pop_show:false,
      batch_type:'price',
      batch_val:'',
      style_category:{},
      design_category_list:[],
      setting:{}
    };
  },
  watch: {
    // 监听路由参数的变化
    "$route.query.uuid": {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        if (newVal !== oldVal && newVal != 0) {
          // 更新数据
          this.uuid = newVal;
          this.getProduct();
        }
      },
      immediate: true, // 立即执行一次handler以初始化数据
      deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
    }

  },

  computed: {
    is_new() {
      if(this.design_uuid) {
        return true
      }
      if(!isNaN(Number(this.uuid))) {
        return true
      }
      
      return false
    },
    child_category_list() {
      const { form_data, product_category_list } = this;
      const { category_id_1 } = form_data;
      const child_category = product_category_list.filter((item) => {
        return item.product_category_id === category_id_1;
      })[0]?.children;
      return child_category || [];
    },
    child_design_category_list(){
      const {form_data,design_category_list} = this;
      const {parent_product_category_id} = form_data;
      const child_category = design_category_list.filter((item)=>{
        return item.product_category_id === parent_product_category_id;
      })[0]?.children;
      return child_category || [];
    },
    showToolTip(){
      const {uuid,design_uuid} = this.$route.query;
      // 只要有一个有效参数就显示 tooltip
      const hasValidUuid = uuid && uuid !== '0';
      const hasValidDesignUuid = design_uuid && design_uuid !== '0';

      if ((hasValidUuid || hasValidDesignUuid) && this.form_data.design_id>0) {
        console.log('tooltip true');
        return true;
      }
      console.log('tooltip false');
      return false;
    }
  },
  methods: {
    async onGetSetting(){
        try{
            const {code,msg,data} = await getSetting({code:'mall',key:'index'})
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            this.setting = data;
            console.log('data--->setting',data);
        }catch(err){
            console.log('get-setting-error',err);
        }
    },
    onPriceModeChange(val){
      console.log('onPriceModeChange',val);
      if(val == 2){
        this.$set(this.form_data,'price_step',[]);
        this.form_data.price_step.push({min:'',price:''})
      }
      this.form_data.mqq = '';
    },
    openColorPopup() {
      console.log('selected_color',this.selected_color);
      // 将已选颜色 ID 同步到临时选择列表
      this.temp_color_ids = this.selected_color.map(item =>{
        const colorId = item.color_id;
        return colorId;
      });
      console.log('this.temp_color_ids',this.temp_color_ids);
      this.is_choose_color_popup_show = true;
    },
    onPriceStepInput({target},index,type){
      const {value} = target;
      console.log('e-input',value,'index',index,'type',type);
      const {price_step} = this.form_data;

      if(type === 'num'){
        if(index == 0 && this.form_data.mqq && this.form_data.mqq > value){
          this.$layer.msg('档位值不可小余最小起订值~');
          this.$set(this.form_data.price_step[index],'min',0);
          return;
        }else{
          if(price_step.some((item, i) => {
              // 只检查当前行之前的行
              if(i >= index) return false;

              // 前面的档位 min 不能大于当前输入值
              const prevMin = Number(item.min) || 0;
              const currValue = Number(value) || 0;

              console.log('检查:', i, '<', index, '且', prevMin, '>', currValue);
              return prevMin > currValue;
          })){
              this.$layer.msg('当前档位数量不能小余上一档~');
              this.$set(this.form_data.price_step[index], 'min', '');
              return;
          }
          if(price_step.some((item,i)=>{
            if(i <= index) return false;
            const nextMin = Number(item.min) || 0;
            const currVal = Number(value) || 0;
            return nextMin < currVal;
          })){
            this.$layer.msg('当前档位数量不能小余上一档~');
            this.$set(this.form_data.price_step[index],'min',0);
            return;
          }
        }
      }

      // if(type === 'price'){
      //   if(index == 0) return;
      //   if(price_step.some((item,i)=>index > i && item.price > value)){
      //     this.$layer.msg('当前价格不能高于')
      //   }
      // }

    },
    onColorImgUploadForTable(file,index){
      uploadFileToOSS(file, "product",true).then((url) => {
        this.$set(this.size_color_table_data[index].color,'color_image',url);
      }).catch(err=>{
        if(err.code === 'IMAGE_SIZE_LIMIT'){
          this.$layer.msg(`图片【${file.name}】像素超过限制,最大宽度不能超过4096或者总体像素值不能超过9437184`);
          return;
        }
      });
      return false;
    },
    onBeforeColorUpload(file,color_index){
      const targetColor = this.selected_color[color_index];
      const colorId = targetColor.color_id;
      uploadFileToOSS(file, "product",true).then((url) => {
        this.$set(this.selected_color[color_index],'color_image',url);
        console.log('selected-color',this.selected_color[color_index]);
        this.size_color_table_data.forEach((item, index) => {
          if(item.color.color_id === colorId){
            this.$set(this.size_color_table_data[index].color, 'color_image', url);
          }
        });
      }).catch(err=>{
        if(err.code === 'IMAGE_SIZE_LIMIT'){
          this.$layer.msg(`图片【${file.name}】像素超过限制,最大宽度不能超过4096或者总体像素值不能超过9437184`);
          return;
        }
      });
      return false;
    },
    onPriceStepRemove(index){
      if(this.form_data.price_step.length == 1){
        this.$layer.msg('至少需设置一个区间~');
        return;
      }
      this.form_data.price_step.splice(index,1);
    },
    onPriceStepAdd(){
      if(this.form_data.price_step.length>=3){
        this.$layer.msg('最多添加三个区间~');
        return;
      }
      if(this.form_data.price_step.some(item=>!item.min || !item.price)){
        this.$layer.msg('请先完整填写再添加区间~');
        return;
      }
      this.form_data.price_step.push({min:'',price:''});
    },
    onAddSize(){
      if(!this.form_data.sex){
        this.$layer.msg('请先选择性别');
        return;
      }
      this.is_choose_size_popup_show=true
    },
    onChangeSex(val){
      console.log('sex_val',val);
      console.log('style_category',this.style_category);
      if(!this.showToolTip && (!this.style_category || !this.style_category.product_category_id)){
        this.$layer.msg('请先选择款式~');
        return false;
      }
      if(this.size_list && this.size_list.length){
        this.$DModal.confirm({
          content:"切换性别后已选择的尺码会被清空,是否确定切换?",
          onOK:()=>{
            this.size_list = [];
            this.selected_size = [];
            this.size_color_table_data = [];
            this.temp_size_ids = [];
            this.size_list_for_field = [];
            console.log('style_category-after-confirm',this.style_category);
            if(val == 1) {
              this.size_list = this.style_category.size_list_man;
            } else if(val == 2) {
              this.size_list = this.style_category.size_list_woman;
            }else{
              this.size_list = this.style_category.size_list_child;
            }
            console.log('size_list',this.size_list,'val',val);
          }
        })
      }else{
        if(val == 1) {
            this.size_list = this.style_category.size_list_man;
          } else if(val == 2) {
            this.size_list = this.style_category.size_list_woman;
          }else{
            this.size_list = this.style_category.size_list_child;
          }
          this.form_data.sex = val;
      }

      console.log('size_list',this.size_list);
    },
    onParentChange(val){
      console.log('val===>parent-cate',val);
      this.form_data.child_category_id = '';
      this.style_category = this.design_category_list.find(item=>item.product_category_id == val);
      // this.generateSizeColorTableData();
    },
    onChildChange(val){
      console.log('val===>child-cate',val);
      this.style_category = this.design_category_list.find(item=>item.product_category_id == val);
      // this.generateSizeColorTableData();
    },
    onMainCateChange(val){
      console.log('val===>main-cate',val);
      this.form_data.category_id_2 = '';
      // if(this.form_data.sex){
      //   this.onChangeSex(this.form_data.sex);
      // }
    },
    onSubCateChange(val){
      console.log('sub_val',val);
      // if(this.form_data.sex){
      //   this.onChangeSex(this.form_data.sex);
      // }
    },
    onConfirmBatchSet(){
      const {batch_type,batch_val} = this;
      switch(batch_type){
        case 'price':{
          const set_price = this.size_color_table_data.map((item)=>{
            return {...item,price:batch_val}
          })
          this.size_color_table_data = set_price;
          break;
        }
        case 'stock':{
          const set_stock = this.size_color_table_data.map((item)=>{
            return {...item,stock:batch_val}
          });
          this.size_color_table_data = set_stock;
          break;
        }
      }
      this.batch_val = '';
      this.is_batch_pop_show = false;
    },
    onCancelBatchSet(){
      this.batch_val = '';
      this.is_batch_pop_show = false;
    },
    onBatchset(type){
      this.batch_type = type;
      this.is_batch_pop_show = true;
    },
    setPoster(url){
      if(this.form_data.image === url){
        return;
      }
      this.form_data.image = url;
      const index = this.form_data.image_list.findIndex(item => item.raw === url);
      if (index !== -1) {
        const [item] = this.form_data.image_list.splice(index, 1);
        this.form_data.image_list.unshift(item);
      }
    },
     // 拖拽相关方法
    handleDragStart(event, draggedIndex) {
      event.dataTransfer.setData("draggedIndex", draggedIndex);
    },

    handleDrop(event, targetIndex) {
      event.preventDefault();
      const draggedIndex = event.dataTransfer.getData("draggedIndex");

      if (draggedIndex === targetIndex) return;

      const draggedItem = this.form_data.image_list.splice(draggedIndex, 1)[0];
      this.form_data.image_list.splice(targetIndex, 0, draggedItem);
    },
    onParamDel(index){
      this.form_data.param.splice(index,1);
    },
    onModifyColor(color,index){
      console.log('color',color,index);
      this.form_data_modify_color.color_id = color.color_id;
      this.is_modify_color_show = true;
    },
    onModifySize(size,index){
      console.log('size',size,index);
      this.form_data_custom_size.size_key = size.size_key;
      this.is_modify_size_show = true;
    },
    confirm_modify_color(colorId){
      console.log('color_id',colorId);
      const {color_id,color_name} = this.form_data_modify_color;
      const checkIndex = this.size_color_table_data.findIndex((item)=>{
        return item.color.color_id === color_id;
      })
      if(checkIndex == -1){
        this.$layer.msg('数据异常[color_not_found]');
        return;
      }

      const select_res = this.selected_color.map((item)=>{
        if(item.color_id === colorId){
          return {
            color_id:item.color_id,
            color_key:item.color_key,
            color_name:color_name,
            color_name_cn:color_name,
            color_value:item.color_value || '',
            color_image:item.color_image || '',
          }
        }else{
          return item;
        }
      })

      this.selected_color = select_res;

      console.log('selected_color',this.selected_color);

      // 创建一个新的颜色对象,防止直接修改原对象导致的所有同一个color_id的对象被修改
      // 备用方案
      // const updatedColor = {
      //   ...this.size_color_table_data[checkIndex].color,
      //   color_name:color_name
      // }
      // this.size_color_table_data[checkIndex].color = updatedColor;

      this.size_color_table_data[checkIndex].color.color_name = color_name;
      this.form_data_modify_color = {color_id:0,color_name:''}
      this.is_modify_color_show = false;
    },
    del_custom_color(color_id){
      this.color_list = this.color_list.filter((item) => {
        return item.color_id !== color_id;
      });
      const checkColor = this.selected_color.findIndex((item)=>{
        return item.color_id === color_id;
      })
      if(checkColor != -1){
        this.onDelSelectedColor(color_id);
      }
    },
    onDelTableData(colorToRemove,sizeToRemove){
      console.log('color',colorToRemove);
      console.log('size',sizeToRemove);
      // 从 size_color_table_data 中移除指定的项
      this.size_color_table_data = this.size_color_table_data.filter(item =>
        !(item.size.size_key === sizeToRemove.size_key && item.color.color_id === colorToRemove.color_id)
      );

      // 检查被移除的颜色是否还在其他尺码中使用
      const isColorUsedByOtherSizes = this.size_color_table_data.some(item =>
        item.color.color_id === colorToRemove.color_id
      );

      // 如果该颜色没有在其他尺码中使用，则从 selected_color 中移除
      if (!isColorUsedByOtherSizes) {
        this.selected_color = this.selected_color.filter(color =>
          color.color_id !== colorToRemove.color_id
        );
      }

      // 检查被移除的尺码是否还在其他颜色中使用
      const isSizeUsedByOtherColors = this.size_color_table_data.some(item =>
        item.size.size_key === sizeToRemove.size_key
      );

      // 如果该尺码没有在其他颜色中使用，则从 selected_size 中移除
      if (!isSizeUsedByOtherColors) {
        this.selected_size = this.selected_size.filter(size =>
          size !== sizeToRemove.size_key
        );
      }
    },
    onDelSelectedColor(colorId){
      console.log('colorId',colorId);
      this.selected_color = this.selected_color.filter((item)=>{
        return item.color_id !== colorId;
      })
      this.generateSizeColorTableData();
    },
    generateSizeColorTableData(){
      const { selected_size, selected_color, size_color_table_data,form_data } = this;
      const {product_spec} = form_data;
      console.log('product_spec',product_spec);

      // 通过 size_key + color_name 从 product_spec 中查找已存在的 spec_id
      const findSpecBySizeColor = (size_key, color_name) => {
        if(!product_spec || !Array.isArray(product_spec)) return null;
        return product_spec.find((item)=>{
          const size_match = item.attr1_name === size_key || item.attr1_name === size_key;
          const color_match = item.attr2_name === color_name || item.attr2_name === color_name;
          return size_match && color_match;
        });
      };

      // 如果 size_color_table_data 为空，直接生成新的数据
      if (size_color_table_data.length === 0) {
        let table_data = [];
        selected_size.forEach((size) => {
          selected_color.forEach((color) => {
            let exist_spec = findSpecBySizeColor(size.size_key, color.color_name);
            let curr_img = exist_spec ? exist_spec.color_image : '';
            console.log('curr_img',curr_img);
            let val = {
              size: {
                size_key:size.size_key,
                size_alias:size.size_alias,
              },
              color: {...color,color_image:curr_img ? curr_img : color.color_image},
              price: exist_spec ? parseFloat(exist_spec.price) : 0,
              stock: exist_spec ? exist_spec.stock : 0,
              spec_id: exist_spec ? exist_spec.spec_id : 0,
            };
            table_data.push(val);
          });
        });
        this.size_color_table_data = table_data;
      } else {
        // 如果 size_color_table_data 有数据，需要判断当前 selected_size 以及 selected_color 数据是否已经存在于 size_color_table_data
        let existing_table_data = [...size_color_table_data];
        let new_table_data = [];

        selected_size.forEach((size) => {
          selected_color.forEach((color) => {
            // 查找是否已存在相同的 size 和 color 组合（通过 size_key 和 color_id 比较）
            let existingIndex = existing_table_data.findIndex(item =>
              item.size.size_key === size.size_key && item.color.color_id === color.color_id
            );

            if (existingIndex !== -1) {
              // 如果存在，保留原数据（包括可能已被修改的价格和库存以及 spec_id）
              new_table_data.push(existing_table_data[existingIndex]);
              // 从现有数据中移除已处理的项
              existing_table_data.splice(existingIndex, 1);
            } else {
              // 如果不存在，新增数据。尝试从 product_spec 中找到对应 spec_id
              let exist_spec = findSpecBySizeColor(size.size_key, color.color_name);
              let val = {
                size: {
                  size_key:size.size_key,
                  size_alias:size.size_alias
                },
                color: {...color, color_image: exist_spec ? exist_spec.color_image : color.color_image},
                price: exist_spec ? parseFloat(exist_spec.price) : 0,
                stock: exist_spec ? exist_spec.stock : 0,
                spec_id: exist_spec ? exist_spec.spec_id : 0,
              };
              new_table_data.push(val);
            }
          });
        });

        this.size_color_table_data = new_table_data;
      }

      console.log('table_data', this.size_color_table_data);
    },
    // confirm_choose_color_popup() {
    //   console.log('temp_color_ids',this.temp_color_ids);
    //   let confirm_colors = [];
    //   this.temp_color_ids.forEach(item=>{
    //     let val = this.sys_color_list.filter((color)=>{
    //       return color.color_id === item;
    //     })[0];
    //     if(!val){
    //       val = this.color_list.filter((color)=>{
    //         return color.color_id === item;
    //       })[0];
    //     }
    //     confirm_colors.push(val);
    //   })
    //   console.log('confirm_colors',confirm_colors);
    //   // return;
    //   this.selected_color = confirm_colors;
    //   this.temp_color_ids = [];
    //   this.is_choose_color_popup_show = false;
    //   this.generateSizeColorTableData();
    // },
    confirm_choose_color_popup() {
      console.log('temp_color_ids', this.temp_color_ids);
      let confirm_colors = [];

      this.temp_color_ids.forEach(item => {
        // 统一转换为字符串进行比较
        const itemId = String(item);

        // 在 sys_color_list 中查找
        let val = this.sys_color_list.find(color => String(color.color_id) === itemId);

        // 如果没找到，在 color_list 中查找
        if (!val) {
          val = this.color_list.find(color => String(color.color_id) === itemId);
        }

        // ✅ 只添加有效数据，过滤 undefined
        if (val) {
          // 从原 selected_color 中查找，保留已上传的图片
          const existingColor = this.selected_color.find(color => String(color.color_id) === itemId);
          if (existingColor) {
            confirm_colors.push({
              ...val,
              color_image: existingColor.color_image || val.color_image,
              color_name: existingColor.color_name || val.color_name,
              color_name_cn: existingColor.color_name_cn || val.color_name_cn,
            });
          } else {
            confirm_colors.push({ ...val });
          }
        }
      })

      console.log('confirm_colors', confirm_colors);
      this.selected_color = confirm_colors;
      // this.temp_color_ids = [];
      this.is_choose_color_popup_show = false;
      this.generateSizeColorTableData();
    },
    toggle_color(color_id) {
        if (this.temp_color_ids.includes(color_id)) {
          this.temp_color_ids = this.temp_color_ids.filter((item) => {
            return item !== color_id;
          });
        } else {
          this.temp_color_ids.push(color_id);
          this.temp_color_ids = [...new Set(this.temp_color_ids)];
        }
      },
    add_custom_color() {
      // this.is_choose_color_popup_show = true;
      if (this.form_data_custom_color.color_alias.length === 0) {
          this.$layer.msg(`请填写自定义名称`);
          return;
      }
      if (this.form_data_custom_color.color_alias.length > 4) {
        this.$layer.msg(`不超过4个字符`);
        return;
      }
      let uuid = util.uuid().toUpperCase()
      let obj = {
        color_id: uuid,
        color_key: uuid,
        color_name: this.form_data_custom_color.color_alias,
        color_name_cn: this.form_data_custom_color.color_alias,
        color_value: "",
      };
      this.color_list.push(obj);
      this.temp_color_ids.push(obj.color_id);
      this.form_data_custom_color.id = 0;
      this.form_data_custom_color.color_alias = "";
    },
    confirm_modify_size(){
      console.log('confirm_modify_size');
      const {size_key,size_alias} = this.form_data_custom_size;
      // console.log('size_key',size_key,'size_alias',size_alias);
      // console.log('size_color_table_data',this.size_color_table_data);
      // const checkIndex = this.size_color_table_data.findIndex((item)=>{
      //   return item.size.size_key === size_key;
      // })
      // console.log('checkIndex',checkIndex);
      // if(checkIndex == -1){
      //   this.$layer.msg('数据异常[size_key_not_found]');
      //   return;
      // }
      this.selected_size = this.selected_size.map((item)=>{
        if(item.size_key === size_key){
          return {
            size_key:size_key,
            size_alias:size_alias
          }
        }else{
          return item;
        }
      })
      console.log('selected_size',this.selected_size);
      this.size_color_table_data = this.size_color_table_data.map((item)=>{
        if(item.size.size_key === size_key){
          return {
            ...item,
            size:{
              size_key:size_key,
              size_alias:size_alias
            }
          }
        }else{
          return item;
        }
      })
      // this.size_color_table_data[checkIndex].size.size_alias = size_alias;
      this.form_data_custom_size = {size_key:"",size_alias:""};
      this.is_modify_size_show = false;
    },
    onDelSelectedSize({size_key}){
      this.selected_size = this.selected_size.filter((item) => {
        return item.size_key !== size_key;
      });
      this.toggle_size(size_key);
    },
    toggle_size(size_key) {
      console.log('this.temp_size_ids-before',this.temp_size_ids);
      if (this.temp_size_ids.includes(size_key)) {
        console.log('has-size-key',size_key);
        this.temp_size_ids = this.temp_size_ids.filter((item) => {
          return item !== size_key;
        });
        console.log('temp-size_ids-has',this.temp_size_ids);
      } else {
        console.log('no-size-key',size_key);
        this.temp_size_ids.push(size_key);
        console.log('temp-size_ids',this.temp_size_ids);
        this.temp_size_ids = [...new Set(this.temp_size_ids)];
      }
      this.generateSizeColorTableData();
    },
    confirm_choose_size_popup(){
      this.selected_size = this.temp_size_ids.map((item)=>{
        return {
          size_key:item,
          size_alias:item
        }
      })
      // this.temp_size_ids = [];
      this.is_choose_size_popup_show = false;
      this.generateSizeColorTableData();
    },
    onImgListDel(index) {
      this.form_data.image_list.splice(index, 1);
    },
    async processAllFiles(type) {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列
      console.log("queue-file-list:", queue,'length:',queue.length);
      // console.log(`Startting upload ${queue.length} files...`);
      if (queue.length > 5) {
        this.$layer.msg("扣除封面最多只能上传5张图片/视频");
        return;
      }
      for (const file of queue) {
        try {
          const url = await uploadFileToOSS(file, "product",true);
          // this.image_list.push({raw:url,raw_name:file.name});
          if (type === "cover") {
            this.form_data.image = url;
          } else {
            console.log("ffffile===>", file.name, file);
            const data = {};
            data.raw = url;
            data.raw_name = file.name;
            if (util.test_image(file.name)) {
              data.type = "image";
            }
            if (util.is_video(file.name)) {
              data.type = "video";
              const video_check = this.form_data.image_list.filter(item=>{
                return item.type === 'video';
              });
              if(video_check.length>=1){
                this.$layer.msg(`最多只能上传一个视频`);
                return false;
              }
            }
            if (!this.form_data.image_list) {
              this.form_data.image_list = [];
            }
            this.form_data.image_list.push(data);
          }
          console.log("this.image_list", this.image_list);
        } catch (err) {
          console.log("upload-err", err);
          if(err.code === 'IMAGE_SIZE_LIMIT'){
            this.$layer.msg(`图片【${file.name}】像素超过限制,最大宽度不能超过4096或者总体像素值不能超过9437184`);
            return;
          }
          this.$layer.msg(`上传失败=>：${file.name}`);
        }
      }
    },
    onBeforeUpload(file, type) {
      console.log("file-before", file);
      console.log('file-height',file.height);
      if(util.is_video(file.name)){
        const video_check = this.form_data.image_list.filter(item=>{
          return item.type === 'video';
        });
        if(video_check.length >= 1){
          this.$layer.msg(`最多只能上传一个视频`);
          return false;
        }
      }
      this.uploading = true;
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
        this.processAllFiles(type);
      }, this.debounceTime);
      return false;
    },
    change_richtext(e) {
      this.form_data.content = e;
    },
    add_param() {
      // console.log("add_param");
      this.form_data.param.push({ key: "", value: "" });
      // console.log('form_data_param',this.form_data.param);
    },
    delete_param(k) {
      this.form_data.param.splice(k, 1);
    },
    save(is_save=false) {
      if(this.form_data.price_mode === 0){
        this.$layer.msg('请选择报价方式~');
        return;
      }
      let sizeInfo = {};
      for(let i in this.size_info){
        sizeInfo[i] = {};
        for(let s in this.size_info[i]){
          sizeInfo[i][s] = this.size_info[i][s].normal;
        }
      }
      if(!this.selected_size.length || !this.selected_color.length){
        this.$layer.msg('请选择销售尺码和颜色');
        // return;
      }
      if(this.form_data.name.length > 50){
        this.$layer.msg('商品名称不能超过50个字符');
        return;
      }
      const {priceMultipler} = this.setting;
      if(this.form_data.design && this.form_data.design.factory_price){
        const {tag_price,design} = this.form_data;
        const {factory_price} = design;
        const min_tag_price = Math.ceil(Number(factory_price) * Number(priceMultipler) * 100) / 100;
        const num_tag_price = Number(tag_price);
        console.log('tag_price',tag_price,'num_tag_price',num_tag_price,'min_tag_price',min_tag_price,'priceMultipler',priceMultipler);
        if(isNaN(num_tag_price) || num_tag_price <= 0){
          this.$layer.msg('请输入有效的吊牌价');
          return;
        }
        if(num_tag_price < min_tag_price){
          this.$layer.msg(`吊牌价不能低于平台出厂价:¥${min_tag_price}`);
          return;
        }
      }
      console.log('sizeIIInfo',sizeInfo);
      this.form_data.detail = sizeInfo;
      this.form_data.sale_size_list = this.selected_size;
      this.form_data.sale_color_list = this.selected_color;
      this.form_data.spec_data = this.size_color_table_data;
      this.form_data.category_id = this.form_data.category_id_2 ? this.form_data.category_id_2 : this.form_data.category_id_1;
      this.form_data.product_category_id = this.form_data.child_product_category_id ? this.form_data.child_product_category_id : this.form_data.parent_product_category_id;
      this.form_data.design_uuid = this.design_uuid;
      this.form_data.status = 1;
      //>如果form_data.price_mode == 2,取form_data.price_step中最小的min赋值给form_data.mqq
      if(this.form_data.price_mode == 2){
        if(this.form_data.price_step && this.form_data.price_step.length > 0){
            //>从 price_step 数组中找出最小的 min 值
            const minMqq = Math.min(...this.form_data.price_step.map(item => Number(item.min) || 0))
            this.form_data.mqq = minMqq
            const minPrice = Math.min(...this.form_data.price_step.map(item=>Number(item.price) || 0))
            this.form_data.sale_price = minPrice;
        }
      }else{
        //>从size_color_table_data中取出最小price
        const minPrice = Math.min(...this.size_color_table_data.map(item=>Number(item.price) || 0));
        this.form_data.sale_price = minPrice;
      }
      if(!this.form_data.mqq){
        this.$layer.msg('最小起订数不可空~');
        return;
      }
      if(isNaN(this.form_data.sale_price)){
        this.$layer.msg('价格只能输入数字,请输入有效的销售价格~');
        return;
      }
      if(!this.form_data.unit){
        this.$layer.msg('请输入单位~');
        return;
      }

      if(!this.form_data.image){
        const imgs = this.form_data.image_list.filter((item)=>{
          return util.test_image(item.raw);
        })
        if(imgs.length > 0){
          this.form_data.image = imgs[0].raw;
        }
      }
      // console.log('form-data-min-price',this.form_data);
      // return;
      if(is_save){
        this.form_data.status = 0;
      }
      SaveProduct({
        ...this.form_data,
        uuid: this.uuid,
        design_uuid: this.design_uuid,
      })
        .then((response) => {

          if(is_save){
            this.uuid = response.data.uuid;
            this.$layer.msg('保存成功');
            return;
          }
          this.$layer.msg(`操作成功`);

          this.$router.replace({
            name: "ShopManage",
            query: { uid: this.$store.state.userInfo.code },
          });
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
    handleSuccess(response, file, fileList, field) {
      this.$set(this.form_data, field, response.data.url);
    },
    async getProductCategoryList() {
      return getMallCategoryList().then((response) => {
        this.product_category_list = [...response.data];
        return response;
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        this.profile = response.data;
        return response;
      });
    },
    getProduct() {
      this.$Spin.show();
      GetProduct({
        uuid: this.uuid,
      })
        .then(async (response) => {
          console.log('response_data',response.data);
          this.style_category = response.data.productcategory;
          this.form_data = {
                              ...response.data,
                              delivery_mode:response.data.delivery_mode.toString(),
                              price_mode:response.data.price_mode.toString(),
                              mqq:Number(response.data.mqq)
                            };
                            console.log('price_step',response.data.price_step);
          if(!response.data.price_step || !response.data.price_step.length){
            console.log('no-price-step');
            this.$set(this.form_data,'price_step',[]);
            this.form_data.price_step.push({min:'',price:''})
          }
          if(this.form_data.design_id >0){
            if (this.form_data.design.pat) {
              const { size_info, size_list, field_list } =
                this.form_data.design.pat;
              this.size_info = size_info;
              this.size_list = size_list;

              this.field_list = field_list;
              console.log('size-list---->',size_list);
            }
            if(this.form_data.design.material){
              const {material} = this.form_data.design;
              let material_color = material.filter((item)=>{
                return item.alias === '面料A';
              })[0]?.color_list || [];
              if(material_color.length>0){
                this.sys_color_list = material_color;
              }
            }
          }
          if(response.data.sex){
            if(response.data.sex == 1){
              this.size_list = response.data.productcategory.size_list_man;
            }else if(response.data.sex == 2){
              this.size_list = response.data.productcategory.size_list_woman;
            }else{
              this.size_list = response.data.productcategory.size_list;
            }
          }
          console.log('this.size_list',this.size_list);
          this.form_data.param = [
            ...response.data.param,
          ];
          this.selected_color = response.data.sale_color_list;
          this.selected_size = response.data.sale_size_list;
          let arr = [];
          this.selected_size.forEach(item=>{
            arr.push(item.size_key);
          })
          this.temp_size_ids = arr;
          console.log('this.temp-size-ids',this.temp_size_ids);
          await this.generateSizeColorTableData();
          console.log('this.size_color_table_data',this.size_color_table_data);
          const generateSizeColorData = this.size_color_table_data.map((item)=>{
            const matchingSpec = response.data.product_spec.find(spec=>{
              return (spec.attr1_name === item.size.size_key || spec.attr1_name === item.size.size_alias) && (spec.attr2_name === item.color.color_name || spec.attr2_name === item.color.color_name_cn)
            })
            console.log('matchingSpec',matchingSpec,'price',matchingSpec?.price||0,'stock',matchingSpec?.stock || 0);
            return {
              ...item,
              price: matchingSpec ? parseFloat(matchingSpec.price) : 0,
              stock: matchingSpec ? matchingSpec.stock : 0,
              spec_id: matchingSpec ? matchingSpec.spec_id : 0,
            }
          })
          console.log('generateSizeColorData',generateSizeColorData);
          this.size_color_table_data = generateSizeColorData;
          const findCover = this.form_data.image_list.findIndex((item)=>item.raw === this.form_data.image);
          if(findCover !== -1){
            const [item] = this.form_data.image_list.splice(findCover,1);
            this.form_data.image_list.unshift(item);
          }
          console.log("form_data===>", this.form_data);
        })
        .finally(() => {
          this.$Spin.hide();
        });
    },
    async getOpenShop() {
      GetMyShopList().then((response) => {
        this.shop_list = response.data.filter((i) => {
          return i.is_auth == 1;
        });
      });
    },

    asyncShop() {
      this.is_popup_show = true;
    },
    close() {
      this.is_popup_show = false;
    },
    getShopInfo() {
       this.is_popup_show = false;
       this.$refs['KuaiEdit'].show()
    },
    async onGetDesignCategory(){
      try{
        const {code,msg,data} = await ProductCategoryList();
        if(code>0){
          this.$layer.msg(msg);
          return;
        }
        console.log('data---->',data);
        this.design_category_list = data;
      }catch(e){
        console.log('err->',e);
        this.$layer.msg(e.msg);
      }
    }
  },
  mounted() {
    if (this.$route.query.design_uuid) {
      this.design_uuid = this.$route.query.design_uuid;
      this.$Spin.show();
      GetDesign({
        uuid: this.design_uuid,
      })
        .then((response) => {
          console.log('design===>',response.data);
          const {data} = response;
          // this.form_data.code = data.code;
          this.style_category = data.productcategory
          this.form_data.name = data.name;
          this.form_data.image = data.image;
          this.form_data.image_list = data.image_list.map((item)=>{
            if(!item.type){
              console.log(333, item)
              let file_name;
              if(item.raw){
                file_name = item.raw.split('/').pop();
              }else{
                file_name = item.split('/').pop();
              }
              return {
                raw:item.raw || item,
                type:util.is_video(file_name) ? 'video' : 'image',
                raw_name:item.raw_name || file_name
              }
            }else{
              return item;
            }
          });
          this.$set(this.form_data,'price_step',[]);
          this.form_data.price_step.push({min:'',price:''});
          console.log('this.form_data_imgList',this.form_data.image_list);
          console.log('sex',data.sex,typeof data.sex);
          this.form_data.sex = data.sex;
          this.form_data.description = data.description;
          this.onChangeSex(data.sex)
          if (data.pat) {
            console.log('data.pat',data.pat);
            const { size_info, size_list, field_list } = data.pat;
            this.size_info = size_info;
            this.size_list_for_field = size_list;
            this.field_list = field_list;
          }
          if(response.data.material){
            const {material} = data;
            let material_color = material.filter((item)=>{
              return item.alias === '面料A';
            })[0].color_list || [];
            if(material_color.length>0){
              this.sys_color_list = material_color;
            }
          }
          this.form_data.param = [
            { key: "款号", value: "", required: true, key_ro: true },
            { key: "服装版型", value: "", key_ro: true },
            { key: "适用季节", value: "", key_ro: true },
            { key: "厚薄", value: "", key_ro: true },
            { key: "面料成分", value: "", required: true, key_ro: true },
            { key: "里料成分", value: "", required: true, key_ro: true },
            // ...response.data.param,
          ];
          const findCover = this.form_data.image_list.findIndex((item)=>item.raw === this.form_data.image);
          if(findCover !== -1){
            const [item] = this.form_data.image_list.splice(findCover,1);
            this.form_data.image_list.unshift(item);
          }
          // this.form_data.param[0].value = response.data.style_no;
        }).catch(err=>{
          console.log('get-design-err',err);
        })
        .finally(() => {
          this.$Spin.hide();
          console.log("form_data:::", this.form_data);
        });
    }
    axios.all([
      this.getProfile(),
      this.getProductCategoryList(),
      this.onGetDesignCategory(),
      this.getOpenShop(),
      this.onGetSetting()
    ]);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("showFooter", false);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background: rgb(246, 247, 250);
  min-height: 100vh;
  width: 100%;
  max-width: 1910px;
  margin: 0 auto;
  .page-title {
    display: flex;
    align-items: baseline;
    justify-content: start;
    width: 100%;
    max-width: 1211px;
    column-gap: 11px;
    margin-top: 30px;
    margin-bottom: 20px;
    .title {
      font-size: 20px;
      color: #333333;
      font-weight: bold;
    }
    .slogan {
      font-size: 14px;
      color: #6e6e6e;
    }
  }
  .base-info {
    background: #ffffff;
    width: 100%;
    max-width: 1211px;
    border-radius: 5px;
    .base-container {
      padding: 40px;
      display: flex;
      flex-direction: column;
      .reason-box{
        width:100%;
        background:#fefcb8;
        padding:20px;
        margin-bottom:20px;
        .reason-title{
          color:#ff5000;
          font-size:14px;
          span{
            background:#ff5000;
            color:#fff;
            border-radius:50%;
            text-align:center;
            padding:1px 8px;
            margin-right:10px;
          }
        }
        .reason-content{
          color:#666;
          font-size:14px;
        }
      }
      .base-title {
        font-size: 16px;
        color: #1a1a1a;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 15px;
          background: #fa3d5a;
          margin-right: 10px;
        }
      }
      .form {
        width: 100%;
        margin-top: 33px;
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        .form-item {
          display: flex;
          align-items: center;
          column-gap: 10px;
          .item-label-required {
            flex-shrink: 0;
            color: #333333;
            font-size: 14px;
            font-weight: bold;
            &::after {
              content: "*";
              color: #fa3d5a;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .item-label {
            flex-shrink: 0;
            color: #333333;
            font-size: 14px;
            font-weight: bold;
          }
          .item-value {
            flex: 1;
            display: flex;
            align-items: center;
            border: 1px solid #e2e5e9;
            border-radius: 5px;
            height: 43px;
            ::v-deep Input {
              flex: 1;
              border: none;
              outline: none;
              height: 100%;
              width:100%;
              &:focus{
                box-shadow:none;
              }
            }
            ::v-deep .ivu-input-suffix {
              width: 50px;
            }
          }
          .item-value-select {
            flex: 1;
            height: 43px;
            line-height:43px;
            ::v-deep .ivu-select {
              height: 100% !important;
              div {
                // height: 43px;
                span {
                  height: 100%;
                  line-height: 43px;
                }
              }
            }
            ::v-deep .ivu-select-single .ivu-select-selection {
              height: 100% !important;
            }
          }
          .item-value-img {
            flex: 1;
            display: flex;
            flex-direction: column;
            row-gap: 30px;
            .tips {
              color: #808080;
              font-size: 12px;
            }
            .img-box {
              display: flex;
              flex-wrap: wrap;
              row-gap: 15px;
              column-gap: 10px;
              .imgs {
                width: 166px;
                height: 166px;
                object-fit: cover;
                border-radius: 10px;
                border: 1px dashed #dadde0;
                cursor: pointer;
                position: relative;
                &:hover{
                  .set-poster{
                    display:inline-block;
                  }
                }
                .poster {
                  position: absolute;
                  top: 0;
                  left: 0;
                  background: #b7babd;
                  border-radius: 10px 0 10px 0;
                  color: #ffffff;
                  font-size: 12px;
                  padding: 5px 10px;
                  z-index: 10;
                }
                .set-poster{
                  display:none;
                  position:absolute;
                  bottom:0;
                  left:0;
                  width:100%;
                  // height:100%;
                  background:rgba(0,0,0,0.5);
                  // align-items:center;
                  // justify-content:center;
                  text-align: center;
                  color:#ffffff;
                  font-size:18px;
                  cursor:pointer;
                  // pointer-events: none;
                  z-index:20;
                }
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 10px;
                }
                video {
                  width: 100%;
                  height: 100%;
                  border-radius: 10px;
                }
                .remove-icon {
                  position: absolute;
                  top: -5px;
                  right: -5px;
                  cursor: pointer;
                  z-index: 10;
                  width: 25px;
                  height: 25px;
                }
                .poster {
                  position: absolute;
                  top: 0;
                  left: 0;
                  background: #b7babd;
                  border-radius: 10px 0 10px 0;
                  color: #ffffff;
                  font-size: 12px;
                  padding: 5px 10px;
                  z-index: 10;
                }
              }
              .img-item {
                width: 166px;
                height: 166px;
                border-radius: 10px;
                border: 1px dashed #dadde0;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .up-icon {
                  width: 36px;
                  height: 36px;
                }
                .up-text {
                  color: #808080;
                  font-size: 12px;
                }
                .poster {
                  position: absolute;
                  top: 0;
                  left: 0;
                  background: #b7babd;
                  border-radius: 10px 0 10px 0;
                  color: #ffffff;
                  font-size: 12px;
                  padding: 5px 10px;
                  z-index: 100;
                }
              }
            }
            // display:flex;
            // align-items:center;
            // column-gap:10px;
          }
          .item-value-textarea {
            flex: 1;
            height: 131px;
            border-radius: 5px;
            border: 1px solid #e2e5e9;
            overflow: hidden;
            textarea {
              padding: 15px;
              width: 100%;
              height: 100%;
              border: none;
              outline: none;
            }
          }
        }
      }
    }
  }
  .detail-info {
    background: #ffffff;
    width: 100%;
    max-width: 1211px;
    border-radius: 5px;
    margin-top: 15px;
    .detail-container {
      padding: 40px;
      display: flex;
      flex-direction: column;
      .title-line {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .base-title {
          font-size: 16px;
          color: #1a1a1a;
          font-weight: bold;
          line-height: 1.5;
          display: flex;
          align-items: center;
          &::before {
            content: "";
            display: inline-block;
            width: 3px;
            height: 15px;
            background: #fa3d5a;
            margin-right: 10px;
          }
        }
        .add-param-btn {
          background: #f5f5f5;
          text-align: center;
          border-radius: 18px;
          padding: 10px 20px;
          color: #666666;
          font-size: 12px;
          cursor: pointer;
        }
      }
      .detail-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        column-gap: 20px;
        row-gap: 20px;
        margin-top: 30px;
        .detail-form-item {
          display: flex;
          flex: 1;
          min-width: 45%;
          align-items: center;
          column-gap: 10px;
          padding:5px 10px;
          border-radius:5px;
          position:relative;
          &:hover{
            background:#e0e0e0;
            .param-del-item-tooltip{
              display:inline-block;
            }
          }
          .param-del-item-tooltip{
            position:absolute;
            top:-5px;
            right:-5px;
            cursor:pointer;
            width:20px;
            height:20px;
            display:none;
            .del-item{
              position:static;
              width:100%;
              height:100%;
            }
          }

          .form-item-label-required {
            color: #333333;
            font-size: 14px;
            font-weight: bold;
            text-align: right;
            flex-shrink: 0;
            flex: 0 0 80px;
            display: flex;
            &::after {
              content: "*";
              color: red;
              margin-left: 5px;
              font-size: 14px;
              font-weight: bold;
              display: inline-block;
              vertical-align: middle;
            }
            input {
              width: 100%;
              border: none;
              outline: none;
              text-align:right;
              background:transparent;
            }
          }
          .form-item-label {
            color: #333333;
            font-size: 14px;
            font-weight: bold;
            text-align: right;
            flex-shrink: 0;
            flex: 0 0 80px;
            display: flex;
            input {
              width: 100%;
              border: none;
              outline: none;
              text-align: right;
              background:transparent;
            }
          }
          .form-item-value {
            flex: 1;
            border: 1px solid #e2e5e9;
            border-radius: 5px;
            height: 43px;
            display: flex;
            align-items: center;
            background:#ffffff;
            input {
              border: none;
              outline: none;
              width: 100%;
              padding: 0 20px;
            }
          }
        }
      }
    }
  }
  .size-info {
    background: #ffffff;
    width: 100%;
    max-width: 1211px;
    border-radius: 5px;
    margin-top: 15px;
    .size-container {
      padding: 40px;
      display: flex;
      flex-direction: column;
      .base-title {
        font-size: 16px;
        color: #1a1a1a;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 15px;
          background: #fa3d5a;
          margin-right: 10px;
        }
      }
      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        text-align: center;
        border: 1px solid #e0e0e0;
        margin-top: 30px;
        tr {
          height: 42px;
        }
        th,
        td {
          border: 1px solid #e0e0e0;
        }
        thead > tr {
          background: #f2f4f7;
        }
        tbody > tr > td {
          .add-size-btn {
            width: 162px;
            height: 28px;
            line-height: 28px;
            margin-left: 5px;
            text-align: center;
            background: #f2f4f7;
            color: #666666;
            font-size: 14px;
          }
        }
      }
      .size-tips {
        margin-top: 20px;
        font-size: 12px;
        color: #808080;
        .tips-label {
          color: #fa3d5a;
        }
      }
    }
  }
  .sale-info {
    background: #ffffff;
    width: 100%;
    max-width: 1211px;
    border-radius: 5px;
    margin-top: 15px;
    .sale-container {
      padding: 40px;
      display: flex;
      flex-direction: column;
      .base-title {
        font-size: 16px;
        color: #1a1a1a;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 15px;
          background: #fa3d5a;
          margin-right: 10px;
        }
      }
      .choose-label {
        font-weight: bold;
        font-size: 15px;
        color: #1a1a1a;
        margin-bottom: 15px;
      }
      .choose-form {
        width: 100%;
        min-height: 60px;
        border-radius: 5px;
        border: 1px solid #dad5d1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        margin-bottom: 24px;
        .form-item-box {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          padding: 10px 0;
          align-items: center;
          // overflow:auto;
          // column-gap:10px;
          .form-item {
            background: #f5f5f5;
            position: relative;
            color: #1a1a1a;
            //text-align: center;
            display:flex;
            align-items:center;
            justify-content:center;
            column-gap:10px;
            padding:5px 10px;
            .item-name {
              // padding: 5px 10px;
            }
            ::v-deep .ivu-upload{
              display:flex;
              align-items:center;
              justify-content:center;
            }
            .color-img{
              width:30px;
              height:30px;
              border-radius:4px;
              border:1px solid #e0e0e0;
              cursor:pointer;
              object-fit:cover;
            }

            .del-item {
              position: absolute;
              top: 1px;
              right: 0px;
              font-size: 12px;
              cursor: pointer;
            }
          }
        }
        .add-btn {
          background: #fbe8eb;
          color: #fa3d6a;
          font-size: 12px;
          text-align: center;
          padding: 8px 11px;
          cursor: pointer;
          border-radius: 14px;
        }
      }
      .sale-form{
        display:flex;
        flex-direction:column;
        width:100%;
        row-gap:24px;
        margin-bottom:24px;
        .sale-form-item{
          width:100%;
          display:flex;
          align-items:center;
          column-gap:10px;
          &.align-start{
            align-items:flex-start;
          }
          .sale-form-item-label{
            color:#1a1a1a;
            font-size:15px;
            font-weight:bold;
            flex-shrink:0;
            &.required::after{
              content:"*";
              color: #fe5353;
            }
          }
          .sale-form-item-value{
            display:flex;
            align-items:center;
            column-gap:10px;

            table {
              table-layout: fixed;
              border-collapse: collapse;
              td,
              th {
                // width:100%;
                width: 225px;
              }
              thead {
                background: #f8f8f9;
                tr {
                  height: 43px;
                  th {
                    text-align: center;
                    border: 1px solid #e0e0e0;
                    .batch-col{
                      display:flex;
                      align-items:center;
                      justify-content:center;
                      column-gap:10px;
                      span{
                        color:#1b99f1;
                        font-size:12px;
                        cursor:pointer;
                      }
                    }
                  }
                }
              }
              tbody {
                tr {
                  height: 43px;
                  &:hover {
                    background: #f5f5f5;
                  }
                  &.no-hover{
                    &:hover{
                      background:transparent;
                    }
                  }
                  td {
                    border: 1px solid #e0e0e0;
                    text-align: center;
                    align-items: center;
                    padding: 0 10px;
                    &.no-padding{
                      padding:0;
                      height:100%;
                    }
                    .size-selected {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      column-gap: 5px;
                      .icon-edit {
                        width: 12px;
                        height: 12px;
                        margin: 0 10px;
                      }
                    }
                    .color-selected {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      .icon-edit {
                        width: 12px;
                        height: 12px;
                        margin: 0 10px;
                      }
                    }
                    .color-img-col{
                      display:flex;
                      justify-content:center;
                      align-items:center;
                      column-gap:12px;
                      .color-img{
                        width:31px;
                        height:31px;
                        border-radius:4px;
                        object-fit:cover;
                        &.has-img{
                          border:1px solid #e0e0e0;
                          &:hover{
                            border:1px solid #1b99f1;
                          }
                        }
                        &.no-img{
                          border:1px dashed #e0e0e0;
                          &:hover{
                            border:1px dashed #1b99f1;
                          }
                        }
                      }
                      .img-btn{
                        color:#666;
                        font-size:14px;
                        cursor:pointer;
                      }
                    }
                    .input-no-border{
                      border:none;
                      ::v-deep .ivu-input{
                        border:none !important;
                        outline:none !important;
                        text-align:center;
                        &:focus{
                          box-shadow:none;
                        }
                      }
                    }
                    .price-step-op{
                      display:flex;
                      align-items:center;
                      justify-content:center;
                      column-gap:29px;
                      background:#f8f8f9;
                      width:100%;
                      height:43px;
                      .disabled{
                        color:#999;
                        cursor:not-allowed;
                      }
                    }
                    .operate-selected {
                      cursor: pointer;
                      &:hover {
                        color: #fa3d5a;
                      }
                    }
                    input {
                      width: 100%;
                      height: 30px;
                      border: 1px solid #e0e0e0;
                      border-radius: 3px;
                      outline: none;
                      text-align: center;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .product-price-box {
        width: 100%;
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 50px;
        .price-item {
          display: flex;
          align-items: center;
          flex: 1;
          column-gap: 10px;
          .price-label {
            color: #333333;
            font-size: 14px;
            font-weight: bold;
            &::after {
              content: "*";
              color: #fa3d5a;
            }
          }
          input {
            border: 1px solid #e2e5e9;
            border-radius: 5px;
            height: 43px;
            flex: 1;
            padding: 0 10px;
          }
          span {
            color: #333333;
            font-size: 14px;
          }
        }
      }
    }
  }
  .detail-content-info {
    background: #ffffff;
    width: 100%;
    max-width: 1211px;
    border-radius: 5px;
    margin-top: 15px;
    margin-bottom: 100px;
    .detail-container {
      padding: 40px;
      display: flex;
      flex-direction: column;
      .base-title {
        font-size: 16px;
        color: #1a1a1a;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        align-items: center;
        &::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 15px;
          background: #fa3d5a;
          margin-right: 10px;
        }
      }
    }
  }
  .bottom-menu {
    width: 100%;
    height: 80px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 15px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 2;
    box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, 0.2);
    .btn-items {
      background: #ffffff;
      text-align: center;
      // height:44px;
      // line-height:44px;
      border: 1px solid #d1d1d1;
      border-radius: 5px;
      color: #333333;
      font-size: 14px;
      padding: 10px 30px;
      cursor: pointer;
      &:last-child {
        background: #fa3d5a;
        color: #ffffff;
      }
    }
  }
  .popup {
      padding: 20px;
      .title {
        font-size: 18px;
        font-weight: bold;
        color: #1a1a1a;
        text-align: center;
      }

      .batch-form{
        width:100%;
        margin-top:20px;
        .batch-form-item{
          display:flex;
          flex-direction:column;
          row-gap:10px;
          input{
            border-radius:5px;
            border:1px solid #e0e0e0;
            width:100%;
            height:40px;
            padding:0 10px;
          }
        }
        .btn-box{
          display:flex;
          align-items:center;
          justify-content: center;
          column-gap:20px;
          margin-top:20px;
          Button{
            width:100px;
            height:40px;
            &:last-child{
              background:#fa3d5a;
              color:#ffffff;
            }
          }
        }
      }

      .color-list {
        height: 420px;
        overflow-y: auto;
        border: 1px solid #e0e0e0;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: flex-start;
        .color-item {
          position: relative;
          margin: 5px 10px;
          padding-right: 10px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: #f5f5f5;
          width: 90px;
          height: 38px;
          border-radius: 5px;
          img {
            width: 26px;
            height: 26px;
            &.icon-del {
              position: absolute;
              top: 3px;
              right: 3px;
              width: 16px;
              height: 16px;
              z-index: 100;
            }
          }
          &.active {
            border: 1px solid #fa3d5a;
          }
        }
      }

      .size-list {
        height: auto;
      }

      .form-group {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px 0;
        .label {
          background: #e2e5e9;
          width: 140px;
          height: 51px;
          line-height: 51px;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
        }
        .input {
          width: 320px;
          height: 51px;
          line-height: 51px;
          outline: none;
          border: 1px solid #e2e5e9;
          padding: 0 20px;
        }
        .btn-add {
          margin-left: -96px;
          width: 88px;
          height: 36px;
          line-height: 36px;
          color: white;
          background: #fa3d5a;
          border-radius: 18px;
          text-align: center;
        }
      }

      .tip {
        color: #808080;
        span {
          color: #fa3d5a;
        }
      }

      .btn-modify {
        margin: 20px auto;
        width: 150px;
        height: 38px;
        line-height: 38px;
        color: white;
        font-size: 14px;
        background: #000000;
        border-radius: 5px;
        text-align: center;
      }
    }
}
 ::v-deep .ivu-input {
		width: 300px;
		height: 48px;
		line-height: 48px;
		border: 1px solid #E3E3E3;
		border-radius: 10px;
		padding: 0 10px;
		outline: none;
	}
  ::v-deep .ivu-cascader-label {
      line-height: 48px;
  }
  ::v-deep .popup-modal {
			h2 {
				padding: 10px 20px;
				color: #333333;
				font-size: 18px;
				font-weight: bold;
				border-bottom: 1px solid #F0F0F0;
			}
			.form {
				padding: 10px 0;
				.form-group {
					display: flex;
					flex-wrap: wrap;
					justify-content: left;
					align-items: center;
					margin-top: 20px;
					.form-label {
						width: 100px;
						font-size: 14px;
						color: #696A6A;
						text-align: right;
					}
					.form-control {
						position: relative;
						.input,select {
							width: 300px;
							height: 48px;
							line-height: 48px;
							border: 1px solid #D9D9D9;
							border-radius: 5px;
							padding: 0 10px;
							outline: none;
							font-size: 14px;
							&[readonly] {
								border: none;
							}
						}

					}
				}

				.btn-submit {
					margin: 40px auto;
					width: 200px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 6px;
					cursor: pointer;
				}

			}
		}

::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff5967;
    &::after{
      background:#ff5967;
    }
}

::v-deep .ivu-radio-focus {
    -webkit-box-shadow: 0 0 0 2px #ff596733;
    box-shadow: 0 0 0 2px #ff596733;
    z-index: 1;
}

::v-deep .ivu-radio-wrapper{
  color:#333;
  font-size:14px;
}
::v-deep .ivu-tooltip{
  width:100%;
}
</style>
